import React, {useState, useMemo, useRef} from "react"
import useWindowSize from "hooks/useWindowSize"
import Radiobuttons from "./Radiobuttons"
import "./Injury.css"


const OPSTA_STANJA = 'Opšta stanja'

export default function Injury(params) {

    const {rescue, injury, values, id, setInjury, removeInjury} = params
    const bodyRef = useRef()
    const [windowWidth, windowHeight] = useWindowSize()
    const [updateCounter, setUpdateCounter] = useState(0)
    
    const body_regions = useMemo(() => {
        if (!values?.body_parts) return []
        const body_regions = values.body_parts.map(body_part => body_part.region)
        body_regions.push(OPSTA_STANJA)
        return body_regions
    }, [values])
    
    const body_parts = useMemo(() => {
        if (!values?.body_parts) return []
    
        for (const body_region of values?.body_parts) {
            if (body_region.region === injury.body_region)
                return body_region.values
        }
        return []
    }, [injury.body_region, values?.body_parts])
    
    const onChange = (field, value) => {
        console.log("OC")
        const updated = {...injury}
        updated[field] = value
        setInjury(id, updated)
    }
    
    const getImageURL = () => {
        if (!values?.body_images) return ""
        for (const body_image of values?.body_images)
            if (body_image.id === injury.image_id)
                return body_image.url
        return ""
    }
    
    const updateMarker = () => {
        window.setTimeout(() => setUpdateCounter(counter => counter + 1), 10)
    }
    
    const markerStyle = useMemo(() => {
        if (!bodyRef?.current) {
            updateMarker()
            return {}
        }
        const markerSize = bodyRef.current.offsetWidth * 2 * injury.r
        if (markerSize === 0) {
            updateMarker()
            return {}
        }
        
        return {
            left: `calc(${100 * injury.x}% - ${markerSize / 2}px)`,
            top: `calc(${100 * injury.y}% - ${markerSize / 2}px)`,
            width: `${markerSize}px`,
            height: `${markerSize}px`
        }
    }, [injury, updateCounter, windowWidth, windowHeight])
    
    
    const onBodyClick = (event) => {
        const clickedElement = event.target
        const absoluteX = event.clientX
        const absoluteY = event.clientY
        const rect = clickedElement.getBoundingClientRect()
        const relativeX = (absoluteX - rect.left) / rect.width
        const relativeY = (absoluteY - rect.top) / rect.height
        const updated = {...injury}
        updated.x = relativeX
		updated.y = relativeY
		updated.r = 0.025
        setInjury(id, updated)
    }
    
    const nextImage = () => {
        if (!values?.body_images) return
        
        let i = 0
        while (i < values.body_images.length) {
            if (values.body_images[i].id === injury.image_id) {
                const j = (i + 1) % values.body_images.length
                const updated = {...injury}
                updated.image_id = values.body_images[j].id
                setInjury(id, updated)
                return
            }
            i++
        }
    }
    
    const showBody = !!injury.body_region && injury.body_region !== OPSTA_STANJA

    return <div className="injury">
    	  <div className="subsection">
              <div className="body-region">
                  <Radiobuttons values={body_regions} selected={injury.body_region} onChange={body_region => onChange("body_region", body_region)}/>
              </div>
              <div className="injury-fields">
                    {showBody && <>
                       <label className="field border body-part">
                     	  <span>Deo tela</span>
                     	  <input value={injury.body_part ?? ""} type="text" list={`body-part-list-${id}`} className="body-part" placeholder="Izaberi ili upiši deo tela..." onChange={event => onChange("body_part", event.target.value)} readOnly={rescue.isReadOnly}/>
                     	  <datalist id={`body-part-list-${id}`}>
                         	  {body_parts.map(value => <option key={value} value={value}/>)}
                     	  </datalist>
                 	  </label>
                   	  <label className="field border injury-type">
                       	  <span>Vrsta povrede</span>
                             <input value={injury.type ?? ""} type="text" list="injury-type-list" className="injury-type" placeholder="Izaberi ili upiši vrstu povrede..." onChange={event => onChange("type", event.target.value)} readOnly={rescue.isReadOnly}/>
                       	  <datalist id="injury-type-list">
                           	  {values?.injuries?.map(value => <option key={value} value={value}/>)}
                             </datalist>
                   	  </label>
                   	</>}
                                            
                    {injury?.body_region === OPSTA_STANJA &&
                        <label className="field border body-state">
                      	  <span>Stanje</span>
                      	  <input value={injury.type} type="text" list="body-state-list" className="body-state" placeholder="npr. Potres mozga" onChange={event => onChange("type", event.target.value)}  readOnly={rescue.isReadOnly}/>
                      	  <datalist id="body-state-list">
                          	  {values?.body_states?.map(value => <option key={value} value={value}/>)}
                            </datalist>
                        </label>
                    }
              </div>
              {!rescue.isReadOnly && <div className="injury-buttons">
                {showBody &&
                    <button className="btn btn-light btn-sm" data-inc="1" onClick={nextImage}><i className="fa fa-undo"/>&nbsp;&nbsp;Okreni sliku</button>
                }
                <button className="btn btn-light btn-sm" onClick={() => removeInjury(id)}><i className="fas fa-xmark"/>&nbsp;&nbsp;Ukloni povredu</button>
              </div>}
          </div>
          
          {showBody &&
    	      <div className="body-container">
            	  <div className="body" ref={bodyRef} onClick={onBodyClick}>
                	  <div className="body-marker" style={markerStyle}></div>
                	  <img alt="" src={getImageURL()}/>
            	  </div>
        	  </div>
    	  }
    </div>
}